exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3NRgTLvWbyfWD-1xileYWR {\n  overflow-x: scroll;\n  font-family: \"Monaco\", monospace;\n  font-size: 12px;\n  margin: 0;\n  white-space: pre;\n  background-color: #222222;\n  color: #d6d6d6;\n  font-weight: 400;\n  will-change: initial;\n  outline: none;\n}\n\n._Z1mYiD5z7OQvtbdHBEZT {\n  background-color: #ffff00;\n  color: #222222;\n}\n", ""]);

// exports
exports.locals = {
	"lazyLog": "_3NRgTLvWbyfWD-1xileYWR",
	"searchMatch": "_Z1mYiD5z7OQvtbdHBEZT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./src/components/LazyLog/index.module.css
// module id = 32
// module chunks = 0 1